import React, { useContext } from 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { I18n } from '@fiverr-private/fiverr_context';
import Filters from '../../../../config/filters';
import { AppContext } from '../../../context/listingsContext';
import Modalities from '../../modalities/Modalities';
import { DynamicGigListings, RecommendationsCarousels, Pagination, BusinessEmptyResults } from '../../index';
import SupportChat from '../../SupportChat';

import './index.scss';

const HIGH_QUALITY_BUSINESS_SOURCE = 'high_quality_business_gigs';
const REST_OF_GIGS_BUSINESS_SOURCE = 'rest_of_business_gigs';

const BusinessListings = () => {
    const {
        isTouch,
        listings: [listings],
        filter,
        pagination,
        sorting
    } = useContext(AppContext);

    const { gigs, choiceModalities, restOfGigs, context } = listings;

    const proFilter = filter.topBar.find((filter) => filter.id === Filters.FILTER.PRO.ID);
    const isProFilterToggled = proFilter && proFilter.options.length && proFilter.options[0].selected;

    const hasHighQualityGigs = gigs && gigs.length > 0;
    const hasRestOfGigs = restOfGigs && restOfGigs.length > 0;
    const noGigs = !hasHighQualityGigs && !hasRestOfGigs;

    const highQualityContext = { ...context, sourceComponent: HIGH_QUALITY_BUSINESS_SOURCE };
    const restOfGigsContext = { ...context, sourceComponent: REST_OF_GIGS_BUSINESS_SOURCE };

    const highQualityCarouselTitle = (
        isProFilterToggled
            ? 'search_perseus.fiverr_business.high_quality_carousel_pro_enabled'
            : 'search_perseus.fiverr_business.high_quality_carousel_updated'
    );

    const moreServicesTitle = (
        isProFilterToggled
            ? 'search_perseus.fiverr_business.more_services_pro_enabled'
            : 'search_perseus.fiverr_business.more_services'
    );

    return (
        <>
            <div className="row content-row fiverr-business">
                <div className="content">
                    {noGigs && <BusinessEmptyResults hasFilters={true}/>}
                    <div className="listings-wrapper">
                        { !isEmpty(choiceModalities) && !isEmpty(choiceModalities.buckets) &&
                            <div className="row modalities-row">
                                <Modalities listing={listings}/>
                            </div>
                        }
                        {
                            hasHighQualityGigs &&
                            <div className="listings-wrapper">
                                <h4><I18n k={highQualityCarouselTitle}/></h4>
                                <DynamicGigListings listings={{ ...listings, context: highQualityContext }}/>
                            </div>
                        }
                        {
                            hasRestOfGigs &&
                            <div className={classNames('listings-wrapper', { 'top-padding' : hasHighQualityGigs })}>
                                <h4><I18n k={moreServicesTitle}/></h4>
                                <DynamicGigListings listings={{ ...listings, gigs: restOfGigs, context: restOfGigsContext }}/>
                            </div>
                        }
                    </div>
                </div>

                {window && window.location && <Pagination pagination={pagination}/>}
                {!noGigs && <SupportChat reason="reason_listing-chat"/>}
            </div>

            {!isTouch && <RecommendationsCarousels sorting={sorting} activeFilters={filter.active} loggedIn={true}/>}
        </>
    );
};

export default BusinessListings;
